<template>
    <div class="info-modal hide">

        <div class="info-modal-content">
            <button class="close-btn" @click="closeModal"><img src="@/assets/img/modal/close.svg" /></button>

            <div class="basic-content">
                <h2>BSFQ<sup>1</sup></h2>

                <p><b>The BSFQ assessment measures areas of ADHD dysfunction in the early morning</b> using 20 items
                    (eating
                    breakfast, hygiene, getting to school, etc). Caregivers rate their child’s functional impairment on
                    a
                    severity scale of 0 to 3.</p>

                <p><b style="color:#30368C">0 = None<br />
                        1 = Mild<br />
                        2 = Moderate<br />
                        3 = Severe<br />
                    </b>
                </p>



            </div>
            <div class="refs">
                <p><b>References: 1.</b> Faraone SV, Hammerness PG, Wilens TE. Reliability and validity of the
                    before-school functioning scale in children with ADHD. <i>J Atten Disord</i>.
                    2018;22(11):1040-1048.</p>
            </div>

        </div>

    </div>
</template>

<script>
export default {


    props: {
        showModal: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        if (this.showModal == true) {
            document.body.classList.add("overflow")
            this.$el.classList.remove('hide')
        }
    },
    watch: {
        showModal(newValue, oldValue) {
            console.log(newValue);
            if (newValue === true) {
                this.modalActive();
            }
        }
    },

    methods: {
        modalActive: function () {
            document.body.classList.add("overflow")
            this.$el.classList.remove('hide')
        },

        closeModal() {
            document.body.classList.remove("overflow")
            this.$el.classList.add('hide')
            this.$emit('closeModal')
        },
    }

}
</script>
<style lang="scss" scoped>
.info-modal-content .basic-content {
    padding-right: 50px;
}

.info-modal-content {
    p {
        font-size: 20px;
        line-height: 1.2;
    }
}
</style>